import type { FC } from "react";
import type { ICategory } from "app/common/services/categoryService.types";
import { allTrackers } from "app/services/track/track";
import styled from "styled-components";
import categoryService from "app/common/services/categoryService";
import { SharedCustomIndustryItem } from "app/pages/industry-analysis/home/enriched-custom-industries/SharedCustomIndustryItem";
import { CustomIndustryItem } from "app/pages/industry-analysis/home/enriched-custom-industries/CustomIndustryItem";

export interface IActionItemsBase {
    onEdit?: VoidFunction;
    onShare?: VoidFunction;
    onDelete?: VoidFunction;
    onClone?: VoidFunction;
}

interface IActionItems extends IActionItemsBase {
    industry: ICategory;
}

const Container = styled.div`
    display: flex;
    justify-content: flex-end;
    align-items: center;
`;

export const ActionItems: FC<IActionItems> = (props) => {
    const { industry, onDelete, onShare, onEdit, onClone } = props;
    const { isShared } = industry;

    const onCloneClick = (event) => {
        event.stopPropagation();
        onClone();
        allTrackers.trackEvent("Button", "click", "Duplicate/Custom Industry/homepage");
    };

    return (
        <Container>
            {isShared ? (
                categoryService.hasSmartSharingPermission() && (
                    <SharedCustomIndustryItem
                        industry={industry}
                        onCloneClick={onCloneClick}
                    />
                )
            ) : (
                <CustomIndustryItem
                    industry={industry}
                    onEdit={onEdit}
                    onShare={onShare}
                    onDelete={onDelete}
                />
            )}
        </Container>
    );
};
